import { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { X, Calendar, Clock, CheckCircle } from "lucide-react";
import "../css/rescheduleModal.css";

const RescheduleModal = ({ schedule, patient, onClose, onConfirm }) => {
  const initialProcedures = Array.isArray(schedule?.procedures)
    ? schedule.procedures
        .filter((p) => !p.cancel && !p.confirmed)
        .map((proc) => ({
          ...proc,
          date: schedule.date || "",
          time: proc.time_booked || "",
        }))
    : [];

  const [updatedProcedures, setUpdatedProcedures] = useState(initialProcedures);

  const handleProcedureChange = (index, field, value) => {
    const updated = [...updatedProcedures];
    updated[index][field] = value;
    setUpdatedProcedures(updated);
  };

  const handleConfirm = () => {
    const payload = {
      items: updatedProcedures.map((p) => ({
        scheduling_id: p.scheduling_id,
        procedure_id: p.procedure_id,
        date_scheduling: p.date,
        time_booked: p.time,
      })),
    };
    console.log("Procedimentos selecionados:", payload);
    if (onConfirm) onConfirm(payload);
    onClose();
  };

  useEffect(() => {
    console.log("Procedimentos selecionados:", updatedProcedures);
  }, [updatedProcedures]);

  return (
    <div className="modal-overlay">
      <div className="reschedule-modal">
        <div className="modal-header">
          <h2>Reagendar Procedimentos</h2>
          <button className="close-button" onClick={onClose}>
            <X size={24} />
          </button>
        </div>

        <div className="modal-body">
          <p>
            <strong>Paciente:</strong> {patient?.name}
          </p>
          <p>
            <strong>Médico:</strong>{" "}
            {schedule?.professional_name || "Não informado"}
          </p>

          <div className="procedure-list">
            {updatedProcedures.length === 0 ? (
              <p>Nenhum procedimento agendado para reagendamento.</p>
            ) : (
              updatedProcedures.map((proc, index) => (
                <div key={proc.id} className="procedure-item">
                  <h4>{proc.procedure_name}</h4>

                  <div className="form-group">
                    <label>
                      <Calendar size={16} /> Nova Data:
                    </label>
                    <input
                      type="date"
                      value={proc.date}
                      onChange={(e) =>
                        handleProcedureChange(index, "date", e.target.value)
                      }
                    />
                  </div>

                  <div className="form-group">
                    <label>
                      <Clock size={16} /> Novo Horário:
                    </label>
                    <input
                      type="time"
                      value={proc.time}
                      onChange={(e) =>
                        handleProcedureChange(index, "time", e.target.value)
                      }
                    />
                  </div>
                </div>
              ))
            )}
          </div>
        </div>

        <div className="modal-footer">
          <button className="cancel-button" onClick={onClose}>
            Cancelar
          </button>
          <button
            className="confirm-button"
            onClick={handleConfirm}
            disabled={updatedProcedures.length === 0}>
            <CheckCircle size={16} /> Confirmar Reagendamento
          </button>
        </div>
      </div>
    </div>
  );
};

RescheduleModal.propTypes = {
  schedule: PropTypes.shape({
    procedures: PropTypes.array.isRequired,
    date: PropTypes.string.isRequired,
    professional_name: PropTypes.string,
  }).isRequired,
  patient: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func,
};

export default RescheduleModal;
